export enum PageAction {
  add = 0,
  edit = 1
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/page-action.ts